import 'focus-visible'
import 'objectFitPolyfill'
import 'whatwg-fetch'
import 'details-element-polyfill'
import smoothscroll from 'smoothscroll-polyfill'
import AOS from 'aos'

// Modules
import './_popup-banner'
import './_calendar'
import './_charts'
import './_cookie-though'
import './_slider'
import './_hero'
import './_highlights'
import './_tab-content'
import './_cta'
import './_events-carousel'
import './_events-statement'

((window, document, $) => {
    smoothscroll.polyfill()

    const nav = document.getElementsByClassName('nav')
    const tabs = document.getElementsByClassName('tabs')
    const searchOverlay = document.getElementsByClassName('header__search')
    const searchClear = document.getElementsByClassName('search__clear')
    const svg = '<svg class="ico-arrow-down" width="11" height="12"><use xlink:href="#ico-arrow-down"></use></svg>'
    const audioButton = document.querySelector('.btn-play')
    const audio = document.querySelector('.audio')
    const isTouch = Boolean(window.navigator.userAgent
        .match(/(android|ios|ipad)/i))

    if (!window.Element.prototype.matches)
        window.Element.prototype.matches
            = window.Element.prototype.msMatchesSelector
                || window.Element.prototype.webkitMatchesSelector

    /**
    * Debounce
    * @param  {Function} fn
    * @param  {Integer} time in milliseconds
    * @return {Function}
    */
    const debounce = (fn, time) => {
        let timeout
        return function () {
            const functionCall = () => fn.apply(this, arguments)
            clearTimeout(timeout)
            timeout = setTimeout(functionCall, time)
        }
    }

    /**
    * Get Closest Element
    * @param  {HTML Object} target
    * @param  {String} selector with closest class
    * @return {HTML Object}
    */
    function getClosest (target, selector) {
        let matchesFn;

        // find vendor prefix
        [
            'matches',
            'webkitMatchesSelector',
            'mozMatchesSelector',
            'msMatchesSelector',
            'oMatchesSelector'
        ].some(function (fn) {
            if (typeof document.body[fn] === 'function') {
                matchesFn = fn
                return true
            }
            return false
        })

        let parent

        // traverse parents
        while (target) {
            parent = target.parentElement

            if (parent && parent[matchesFn](selector))
                return parent

            target = parent
        }

        return null
    }

    /**
    * Get Siblings Elements
    * @param  {HTML Object} element
    * @return {Array}
    */
    function getSiblings (element) {
        const siblings = []
        let sibling = element.parentNode.firstChild

        // Loop through each sibling and push to the array
        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== element)
                siblings.push(sibling)

            sibling = sibling.nextSibling
        }

        return siblings
    }

    /**
    * Create Cookie
    * @param  {String} Cookie name
    * @param  {String} Cookie value
    * @oaran  {Integer} Days until expires
    * @return {Void}
    */
    function createCookie (name, value, days) {
        const expires = days
            ? `; expires=${new Date((new Date())
                .setTime((new Date()).getTime()
                    + (days * 24 * 60 * 60 * 1000)))
                .toUTCString()}`
            : ''

        document.cookie = `${name}=${value}${expires}; path=/`
    }

    /**
    * Read Cookie
    * @param  {String} Cookie name
    * @return {String}
    */
    function readCookie (name) { // eslint-disable-line
        const nameEQ = `${name}=`
        const ca = document.cookie.split(';')

        let value = null

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]

            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length)

            if (!c.indexOf(nameEQ)) {
                value = c.substring(nameEQ.length, c.length)
                break
            }
        }

        return value
    }

    /**
    * Close Alert Cookie
    * @param  {HTML Object} Event
    * @return {Void}
    */
    function closeAlertCookie (target) {
        let targetParent = getClosest(target, '.alert__close')

        if (target.matches('.alert__close'))
            targetParent = target

        const alert = getClosest(target, '.alert')

        if (!targetParent || !alert)
            return

        createCookie(`alert-${alert.id}`, true, 15)
    }

    /**
    * Toggle Search Overlay
    * @param  {HTML Object} Event
    * @return {Void}
    */
    function toggleSearchOverlay (event) {
        const target = (event || {}).target
        const isActive = searchOverlay[0].classList
            .contains('header__search_active')

        if (!target && !isActive)
            return

        let targetTrigger = getClosest(target, '.js--searchTrigger')

        if (target.matches('.js--searchTrigger'))
            targetTrigger = target

        if (targetTrigger && !isActive) {
            searchOverlay[0].classList.add('header__search_active')

            if (searchOverlay[0].querySelector('input[type="search"]'))
                searchOverlay[0]
                    .querySelector('input[type="search"]')
                    .focus()

            return event.preventDefault()
        }

        let targetBtnClose = getClosest(target, '.header__search-close')

        if (target.matches('.header__search-close'))
            targetBtnClose = target

        if (isActive
                && (event.keyCode === 27
                    || targetBtnClose === target
                    || !searchOverlay[0].contains(target))) {
            searchOverlay[0].classList.remove('header__search_active')
            event.preventDefault()
        }
    }

    /**
    * Tabs Initialize
    * @param  {NodeList} Tab elements
    * @return {Void}
    */
    function tabsInit (tabs) {
        for (let i = 0; i < tabs.length; i++) {
            const allTab = tabs[i].querySelectorAll('.tab')
            let heightTabs = 0
            let maxHeightTabs = 0

            tabs[i].querySelector('.tabs__body').style.height = ''
            tabs[i].querySelector('.tabs__body').style.maxHeight = ''

            for (var at = 0; at < allTab.length; at++) {
                allTab[at].style.display = 'block'

                if (heightTabs < allTab[at].offsetHeight)
                    heightTabs = allTab[at].offsetHeight

                // Hide innactive tabs
                if (!(allTab[at].classList.contains('tab_active')))
                    allTab[at].style.display = 'none'
                else
                    maxHeightTabs = allTab[at].offsetHeight
            }

            tabs[i].querySelector('.tabs__body')
                .style.height = `${heightTabs}px`

            tabs[i].querySelector('.tabs__body')
                .style.maxHeight = `${maxHeightTabs}px`
        }
    }

    /**
    * Tabs Toggle
    * @param  {Object} Event
    * @return {Void}
    */
    function tabsToggle (event) {
        const target = (event || {}).target

        if (!target.matches('.tabs__nav-link'))
            return

        event.preventDefault()

        if ((target.classList.contains('tabs__nav-link_active')))
            return

        if (isTouch)
            tabsInit(tabs)

        const siblingsLinks = getSiblings(target.parentNode)
        const targetTab = document.getElementById(target
            .getAttribute('href')
            .replace('#', ''))
        const siblingsTabs = getSiblings(targetTab)

        // Add active state
        target.classList.add('tabs__nav-link_active')

        // Remove siblings link active state
        for (let i = 0; i < siblingsLinks.length; i++)
            siblingsLinks[i].querySelector('.tabs__nav-link').classList
                .remove('tabs__nav-link_active')

        // Get target tab height
        targetTab.style.display = 'block'

        const targetTabHeight = targetTab.offsetHeight

        // Set target tab parent max-height
        targetTab.parentNode.style.maxHeight = `${targetTabHeight}px`

        targetTab.style.display = 'none'

        // Make visible target tab
        targetTab.style.display = 'block'
        targetTab.classList.add('tab_active')

        // Hide siblings tabs
        for (let i = 0; i < siblingsTabs.length; i++) {
            siblingsTabs[i].style.display = 'none'
            siblingsTabs[i].classList.remove('tab_active')
        }
    }

    /**
    * Toggle Mega Menu
    * @param  {Object} Event
    * @return {Void}
    */
    function toggleMegaMenu (event) {
        const target = (event || {}).target
        const megaMenuContainer = document.querySelector('.mega-menu')
        const isActive = megaMenuContainer.classList
            .contains('mega-menu_active')

        if (!target && !isActive)
            return

        if (target.classList.contains('header__nav-trigger')
                || target.classList.contains('mega-menu__close')
                || (isActive && event.keyCode === 27)) {
            megaMenuContainer.classList.toggle('mega-menu_active')
            document.documentElement.classList.toggle('scroll-lock')
            document.body.classList.toggle('scroll-lock')
            return event.preventDefault()
        }
    }

    /**
    * Open Nav Dropdown
    * @param  {Object} Event
    * @return {Void}
    */
    function openNavDropdown (event) {
        const target = event.target

        if (!event.target.matches('.nav__item_has_dropdown > .nav__link'))
            return

        const siblingDropdown = getSiblings(target)

        target.classList.toggle('nav__link_active')

        siblingDropdown[0].classList
            .toggle('nav__dropdown_active')

        event.preventDefault()
    }

    /**
    * Close Nav Dropdown
    * @param  {Object} Event
    * @return {Void}
    */
    function closeNavDropdown (target) {
        for (var i = 0; i < nav.length; i++) {
            const navItems = nav[i].querySelectorAll('.nav__item')
            const targetParent = getClosest(target, '.nav__item')

            for (var ni = 0; ni < navItems.length; ni++)
                if (navItems[ni] !== targetParent) {
                    if (navItems[ni].querySelector('.nav__link'))
                        navItems[ni].querySelector('.nav__link')
                            .classList
                            .remove('nav__link_active')

                    if (navItems[ni].querySelector('.nav__dropdown'))
                        navItems[ni].querySelector('.nav__dropdown')
                            .classList
                            .remove('nav__dropdown_active')
                }
        }
    }

    for (let i = 0; i < nav.length; i++) {
        const navItems = nav[i].querySelectorAll('.nav__item')

        for (let _i = 0; _i < navItems.length; _i++)
            if (navItems[_i].querySelectorAll('.nav__dropdown').length) {
                navItems[_i].querySelector('.nav__link').innerHTML += svg
                navItems[_i].classList.add('nav__item_has_dropdown')
            }
    }

    audioButton
        .addEventListener('click', (event) => {
            event.preventDefault()

            const method = audio.classList.contains('play')
                ? 'pause'
                : 'play'

            audio[method]()
            audio.classList.toggle('play')
            audioButton.classList.toggle('off')

            const textHolder = audioButton.querySelector('.btn-play__text')

            textHolder.innerHTML = `Sound ${textHolder.innerHTML === 'Sound On'
                ? 'Off'
                : 'On'}`
        })

    const skipToContent = document.querySelector('#skip-to-content')

    if (skipToContent)
        skipToContent.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopPropagation()

            e.target.blur()

            const main = document.querySelector(e.target.getAttribute('href'))

            if (!main)
                return

            window.scrollTo(0, main.offsetTop)
            main.focus()
            main.blur()
        })

    for (var i = 0; i < searchClear.length; i++)
        searchClear[i]
            .addEventListener('click', function (event) {
                const parent = getClosest(this, '.search')
                parent.querySelector('input').value = ''
                event.preventDefault()
            })

    $('.dropdown_arrow:not(.dropdown_arrow--links) a')
        .click(function (event) {
            $(this).parents('.dropdown')
                .find('.btn')
                .html(`${$(this).text()} <span class="caret"></span>`)

            $(this).parents('.dropdown')
                .find('.btn')
                .val($(this).data('value'))

            $(this).addClass('current').siblings()
                .removeClass('current')

            event.preventDefault()
        })

    document.addEventListener('keyup', function (event) {
        if (event.key !== 'Escape')
            return

        toggleSearchOverlay(event)
        closeNavDropdown(document.body)
        toggleMegaMenu(event)
    })

    // Document Event Listener
    document.addEventListener('click', function (event) {
        const target = event.target

        closeAlertCookie(target)
        toggleSearchOverlay(event)
        tabsToggle(event)
        toggleMegaMenu(event)
        openNavDropdown(event)
        closeNavDropdown(target)
    })

    window
        .addEventListener('resize', () => {
            window.objectFitPolyfill()

            if (!document.documentElement.classList.contains('resizing'))
                document.documentElement.classList.add('resizing')

            if (!isTouch)
                tabsInit(tabs)
        })

    window.addEventListener('resize', !isTouch
        ? debounce(() => {
            if (document.documentElement.classList.contains('resizing'))
                document.documentElement.classList.remove('resizing')

            tabsInit(tabs)
        }, 200)
        : null)

    window.objectFitPolyfill()

    tabsInit(tabs)

    document.body.classList
        .add('ready')

    AOS.init({ once: true })

    const scrollToCurrent = document
        .querySelector('[aria-current="true"][data-current-scroll-to]')

    const scrollToCurrentEl = scrollToCurrent
            && scrollToCurrent.getAttribute('data-current-scroll-to')
            && document.querySelector(
                scrollToCurrent.getAttribute('data-current-scroll-to'))
        ? document.querySelector(
            scrollToCurrent.getAttribute('data-current-scroll-to'))
        : null

    if (scrollToCurrentEl)
        window.addEventListener('load', () =>
            setTimeout(() => {
                scrollToCurrentEl.focus()
                scrollToCurrentEl.blur()
                window.scrollTo(0, $(scrollToCurrentEl).offset().top)
            }, 1))

    setTimeout(() => Array.from(document.querySelectorAll('[data-aos]'))
        .filter(el => {
            const bounds = el.getBoundingClientRect()
            return bounds.top > 0
                && bounds.top < (window.outerHeight
                    + (isTouch
                        ? 60
                        : 0))
                && !el.classList.contains('aos-animate')
        })
        .forEach(el => {
            el.classList.add('aos-animate')
        }), 1000)
})(window, document, window.jQuery)
